const LoadedProfile = (props) => {
    const responseObj = props.responseObj;
    //console.log("From loaded: ", responseObj);
    const reponseError = responseObj.error_code;

    return (
        <>
            {reponseError && (
                <div className="error-page">
                    <h1>No such account found !</h1>
                    <p>{responseObj.message}</p>
                </div>
            )}
            {!reponseError && (
                <>
                    <article className="profile-description">
                        <div className="profile-header">
                            <img
                                src={responseObj.hd_profile_pic_versions[0].url}
                                className="profile-picture"
                                alt="Profile"
                            />
                            <section className="profile-counts">
                                <div className="media-count">
                                    <h3>{responseObj.media_count}</h3>
                                    <p>Posts</p>
                                </div>
                                <div className="follower-count">
                                    <h3>{responseObj.follower_count}</h3>
                                    <p>Followers</p>
                                </div>
                                <div className="following-count">
                                    <h3>{responseObj.following_count}</h3>
                                    <p>Followings</p>
                                </div>
                            </section>
                        </div>
                    </article>
                    <section className="user-intro">
                        <h3 className="username">{responseObj.username}</h3>
                        <p className="fullname">{responseObj.full_name}</p>
                        <p className="bio">{responseObj.biography}</p><br></br>
                        <center>
                            <a href={responseObj.hd_profile_pic_url_info.url+"==.png"} download={responseObj.username+".png"}>
                                <button className="btn"><i class="fa fa-download"></i> Download HD Profile Picture </button>
                            </a>
                        </center>
                    </section>
                    <section className="profile-picture-container">
                        <a href={responseObj.hd_profile_pic_url_info.url+"==.png"} download={responseObj.username+".png"}>
                            <img
                                src={responseObj.hd_profile_pic_url_info.url}
                                className="fullsize-profile-picture"
                                alt="Fullsize"
                            />
                        </a>
                    </section>
                </>
            )}
        </>
    );
};

export default LoadedProfile;
